import { Clickable } from '@carvana/merch-components';
import cx from 'classnames';
import { useContext } from 'react';
import useSendOpenModalEvent, {
  OpenSource
} from '@/SearchResults/ResultTileV2/useSendOpenModalEvent';
import MoreDetailsModalSections from '~/constants/MoreDetailsModalSections';
import ModalContext from '~/contexts/ModalContext';
import { useTileDataContext } from '~/contexts/TileDataContext';
import InfoIcon from '~/icons/InfoIcon';
import { usePriceTerms } from '../hooks';

export default function MonthlyPayment(): JSX.Element | null {
  const { tileData } = useTileDataContext();
  const { setMoreDetailsModalOpen } = useContext(ModalContext);
  const { monthlyPayment = 0, hasTerms } = usePriceTerms();
  const sendOpenEvent = useSendOpenModalEvent();

  const hasValidMonthlyPayment = monthlyPayment > 0;

  return hasTerms ? (
    <div
      data-qa="monthly-payment"
      className={cx('flex gap-4', {
        empty: !hasValidMonthlyPayment
      })}
    >
      ${monthlyPayment}/mo
      <Clickable
        data-analytics-id={null}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          sendOpenEvent(OpenSource.Terms);
          setMoreDetailsModalOpen(true, {
            openTo: MoreDetailsModalSections.PriceDetails,
            vehicleId: tileData.vehicleId
          });
        }}
        className="flex self-center"
        element="span"
      >
        <InfoIcon />
      </Clickable>
    </div>
  ) : null;
}
